export default "__VITE_ASSET__jUI$HGPI__"